import FundList from './FundList';

export default FundList;
